import { render, staticRenderFns } from "./AuthOrAudit.vue?vue&type=template&id=1f922948&scoped=true&"
import script from "./AuthOrAudit.vue?vue&type=script&lang=js&"
export * from "./AuthOrAudit.vue?vue&type=script&lang=js&"
import style0 from "./AuthOrAudit.vue?vue&type=style&index=0&id=1f922948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f922948",
  null
  
)

export default component.exports